import React, {useState} from 'react';
import {useNormalizedModels} from '@common/ui/normalized-model/use-normalized-models';
import {CrupdateResourceSection} from '@app/admin/crupdate-resource-layout';
import {FormChipField} from '@ui/forms/input-field/chip-field/form-chip-field';
import {Item} from '@ui/forms/listbox/item';
import {Trans} from '@ui/i18n/trans';
import clsx from 'clsx';
import {Langue, Sub} from '@app/titles/models/lien';

interface Props {
  type: string;
  label: string;
  endpoint?: string;
  datas?: Langue[] | Sub[] | number[];
  className?: string;
  required?: boolean;
}

export function SelectLanguage({
  endpoint,
  type,
  label,
  className,
  required = false,
  datas = [],
}: Props) {
  const [query, setQuery] = useState('');
  const {data} = useNormalizedModels(endpoint ?? 'normalized-models/lang', {});
  const [selectedLanguages, setSelectedLanguages] = useState(datas);

  return (
    <CrupdateResourceSection
      margin={'mb-0'}
      className={clsx(
        'mb-4 block w-full whitespace-nowrap text-left text-sm first-letter:capitalize',
        className,
      )}
      label={<Trans message={label} />}
    >
      <FormChipField
        className="w-full"
        name={type}
        valueKey={'name'}
        onChange={setSelectedLanguages as any}
        value={selectedLanguages as any}
        suggestions={data?.results.filter(
          suggestion => suggestion.name != 'MULTI',
        )}
        onInputValueChange={setQuery}
      >
        {suggestion => {
          return (
            <Item key={`${type}_${suggestion.id}`} value={suggestion.id}>
              {suggestion.name}
            </Item>
          );
        }}
      </FormChipField>
    </CrupdateResourceSection>
  );
}
